/**
 * React entry point – bootstraps App Bridge and renders the Polaris admin panel.
 */
import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/app.css";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
